export const css = {
    root: 'a2zveMgR',
    title: '-MFBH1fe',
    cards: '_2a9hQLfm',
    studyplan: '_3vaXScnW',
    ' _key': 'afcpe-theme/afcpe/explore-view/chooser'
};
export default css;
